import { apiService } from '@/services/api/apiService';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { ReactNode } from 'react';

export interface AreaManagerCoverage {
    AreaManagerCoverageId: any;
    cityName: ReactNode;
    cityId: any;
    code: string;
    AreaManagerCoverageName: string;
    id: number;
}


interface AreaManagerCoverageState {
    data: AreaManagerCoverage[];
    loading: boolean;
    error: string | null;
}

const PORT = import.meta.env.VITE_COOK_PORT;
const URL = import.meta.env.VITE_API_COOK_URL;

export const softDeleteAreaManagerCoverage: any = createAsyncThunk<
    number,
    number
>(
    "DeleteAreaManagerCoverage/softDeleteAreaManagerCoverage",
    async (id,) => {
        try {
            const response = await apiService.patch(
                `soft_delete_area_manager_coverage?id=${id}`,
                {},
                PORT,
                URL
            );

            return response
        } catch (error: any) {
            return (
                error?.message || "An error occurred while deleting cuisine type"
            );
        }
    }
);


export const AreaManagerCoverageSlice = createSlice({
    name: 'AreaManagerCoverage',
    initialState: {
        data: [],
        loading: false,
        error: null,
    } as AreaManagerCoverageState,
    reducers: {},
    extraReducers: (builder) => {
        builder

    },
});

export default AreaManagerCoverageSlice.reducer;